export const NAME = 'mailroomSentList';